export enum PriceChangeType {
    AUTHOR_TO_FUNDER = 'AUTHOR_TO_FUNDER',
    FUNDER_TO_AUTHOR = 'FUNDER_TO_AUTHOR',
    AUTHOR_TO_AUTHOR_INSTITUTIONAL_DISCOUNT = 'AUTHOR_TO_AUTHOR_INSTITUTIONAL_DISCOUNT',
    FUNDER_TO_FUNDER = 'FUNDER_TO_FUNDER',
    FUNDER_TO_AUTHOR_INSTITUTIONAL_DISCOUNT = 'FUNDER_TO_AUTHOR_INSTITUTIONAL_DISCOUNT',
    AUTHOR_GEOGRAPHIC_WAIVER_TO_AUTHOR = 'AUTHOR_GEOGRAPHIC_WAIVER_TO_AUTHOR',
    AUTHOR_GEOGRAPHIC_DISCOUNT_TO_AUTHOR = 'AUTHOR_GEOGRAPHIC_DISCOUNT_TO_AUTHOR',
}
